import { UpdateEvent } from './events';
import { TokenManager } from './token-manager';
import { TypedEventTarget } from './typed-event-target';

interface AppExternalStoreEventMap {
  update: UpdateEvent;
}

export class AppExternalStore extends
  TypedEventTarget<AppExternalStoreEventMap> {
  static #instance: AppExternalStore | null = null;

  #state = {
    loading: false,
    authenticated: !TokenManager.instance.accessTokenExpired,
  };

  public readonly state;

  private constructor() {
    super();
    AppExternalStore.#instance = this;
    this.state = new Proxy(this.#state, {
      set(target, prop, value, receiver) {
        const prev = Reflect.get(target, prop, receiver);
        const success = Reflect.set(target, prop, value, receiver);

        if (!success || prev === value) return success;

        // Generic update event
        AppExternalStore.instance.dispatchEvent(
          new CustomEvent('update')
        );

        return success;
      },
    });
  }

  public static get instance() {
    return this.#instance ?? new AppExternalStore();
  }
}
